@use "../../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../../styles/Constants.scss" as Constants;

$var-placeholder-width: 80px;

.toggle {
	border-radius: Constants.$val-borderRadius;
	gap: Constants.$val-spacing-m;

	&--empty {
		& > div {
			background-color: Colors.$col-design-grey13;
		}
	}

	&--non-empty {
		& > div {
			border: 1px solid Colors.$col-design-blue500 !important;
			color: Colors.$col-design-blue500;
		}
	}
}

.report-block-field-item {
	display: flex;
	gap: Constants.$val-spacing-xs;
	flex-wrap: wrap;

	&__block-name {
		color: Colors.$col-design-grey10;
	}

	&__field-name {
		text-transform: uppercase;
	}
}

.placeholder {
	display: flex;
	width: $var-placeholder-width;

	&__label {
		text-align: start;
		color: Colors.$col-design-grey900;
		flex: 1;
	}

	&__icons {
		& > [class^="icon-down"] {
			color: Colors.$col-greyDark;
			font-size: Constants.$val-fontSizeRegular;
		}

		& > [class^="icon-close"] {
			color: Colors.$col-greyMid;
			font-size: Constants.$val-fontSizeRegular;
			cursor: pointer;

			&:hover {
				color: Colors.$col-greyDark;
			}
		}
	}
}

.numeric-field {
	display: flex;
	flex-direction: column;
	padding: Constants.$val-spacing-m;
	gap: Constants.$val-spacing-s;

	&__single {
		display: flex;
		padding-bottom: Constants.$val-spacing-s;
	}

	&__compound {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: Constants.$val-spacing-xs;
		flex-direction: row;
		padding-bottom: Constants.$val-spacing-s;

		&__single {
			display: flex;
		}
	}

	&__unit {
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: Colors.$col-greyBackground;
		min-width: 32px;
		color: Colors.$col-greyMid;
		font-weight: bold;
		border: 1px solid Colors.$col-greyMid;
		border-left: none;
		font-size: Constants.$val-fontSizeSmall;
	}

	&__comparator {
		flex: 1;
	}

	&__value {
		width: 100%;
	}
}

.boolean-field {
	display: flex;
	flex-direction: column;
	padding: Constants.$val-spacing-m;
	gap: Constants.$val-spacing-l;
}

.equipment-field {
	display: flex;
	gap: Constants.$val-spacing-xs;
}

.selected {
	margin-right: Constants.$val-spacing-s;
	display: flex;
}

.selected-multiple {
	display: flex;
	gap: Constants.$val-spacing-s;
}

.selected-field-count {
	background-color: Colors.$col-design-blue500;
	color: Colors.$col-white;
	padding: 1px Constants.$val-spacing-s;
	font-size: Constants.$val-fontSizeSmall;
	border-radius: Constants.$val-borderRadius;
	line-height: 1;
	display: flex;
	align-items: center;
}
